import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

// DJ design system — "DEADWEIGHT": a marine costing instrument.
// Petrol-teal housing, warm chart-paper canvas, one signal-brass accent.
// Hex here feeds Vuetify's SASS theme; the raw OKLCH tokens (and the tabular
// mono figure treatment) live in src/assets/styles/app.css.
export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#B4712A", // signal brass  — oklch(0.635 0.108 66)
        secondary: "#0E2A2F", // petrol ink   — oklch(0.255 0.032 196)
        accent: "#B4712A",
        error: "#D0453B", // flare red      — oklch(0.58 0.185 28)
        info: "#2E8B84", // verdigris
        success: "#2E8B84", // verdigris    — oklch(0.60 0.083 190)
        warning: "#C8873B", // brass bright
        background: "#F5F1E8", // chart paper — oklch(0.962 0.014 92)
      },
    },
  },
});
